export class Config {
  //static api_url = "https://api-dev.ansokningsportal.se";   
  //static api_url = "https://api-staging.ansokningsportal.se"; 
  static api_url = "https://localhost:5001";  
  //static api_url = "https://api.ansokningsportal.se";   
}
  
